import { Button } from '@mui/material';
import React from 'react';
import ArrowImage from '../../assets/icons/Arrow 1.png';
import { NavLink } from 'react-router-dom'; // Import NavLink

const GetInTouch = () => {
  return (
    <NavLink 
      to="/contactus" // Set the path you want to navigate to
      style={{ textDecoration: 'none' }} // Remove the underline from the link
    >
      <Button
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 1)',
          color: '#333333',
          fontFamily: 'Plus Jakarta Sans',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem', // Add some space between the text and the arrow
          padding: {xs: '10px 14px', sm: '14px 26px'},
          fontWeight: "700",
          borderRadius: {xs: "5px", sm: "10px"},
          fontSize: {xs: "0.6rem", sm:"0.8rem"}
        }}
      >
        Get In Touch
        <img
          src={ArrowImage} // Ensure this path matches where you've stored the image
          alt="arrow"
          style={{ width: '20px', height: 'auto' }} // You can adjust size here
        />
      </Button>
    </NavLink>
  );
};

export default GetInTouch;
